import { Box, Button, styled, Typography } from "@mui/material";
import { Form } from "formik";

export const StyledAnsweredAuthorizations = {
  ButtonTableActions: styled("button")(({ theme }) => ({
    background: "transparent",
    border: "none",
    margin: "0px 10px 0px 10px",
  })),
  DetailsTableAuthorizationsContainer: styled("div")(({ theme }) => ({
    backgroundColor: "#fafafa",
  })),
  CalendarIcon: styled(Event)(({ theme, editable, hasNotifications }) => ({
    cursor: "pointer",
    color: editable
      ? hasNotifications
        ? theme.palette.primary.main // Estilo cuando hay notificaciones
        : theme.palette.error.main // Estilo cuando no hay notificaciones
      : theme.palette.text.disabled, // Estilo cuando está deshabilitado
  })),
  icon: {
    cursor: "pointer",
  },
  disabledButton: {
    color: "grey",
  },
};

export const StyledPendingAuthorizations = {
  RecibidoPorLaArtContainer: styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 0,
  })),
  RecibidoPorLaArtDate: styled("p")(({ theme }) => ({
    marginRight: 5,
    fontSize: 12,
  })),
  DetailsTableAuthorizationsContainer: styled("div")(
    ({ theme, editable, hasNotifications }) => ({
      backgroundColor: "#fafafa",
    }),
  ),
  icon: {
    cursor: "pointer",
  },
  disabledButton: {
    color: "grey",
  },
};

export const StyledDetailsTable = {
  Container: styled("div")({
    display: "flex",
    flexDirection: "column",
    flex: 1,
  }),
  Content: styled("div")({
    display: "flex",
  }),
  Details: styled("div")({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: "14px",
  }),
  Loading: styled("div")({
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "210px",
  }),
  Table: styled("div")({
    margin: "10px",
  }),
  TextTitle: styled(Typography)({
    fontWeight: "bold",
    fontSize: 16,
  }),
  TextValue: styled(Typography)({
    marginLeft: "18px",
    fontWeight: 300,
    fontSize: 12,
  }),
  AnsweredAuthorizationContainer: styled("div")({
    display: "flex",
  }),
};

export const StyledSearchAuthorizationsForm = {
  ButtonContainer: styled(Box)({
    display: "flex",
    alignItems: "center",
  }),

  StyledButton: styled(Button)(({ theme }) => ({
    margin: theme.spacing(1),
  })),

  checkbox: {
    marginTop: 20,
  },
  inputField: {
    display: "inline-flex",
    marginTop: "10px !important",
    marginRight: 20,
    width: 250,
  },
};

export const StyledSearchContainer = {
  Container: styled("div")({
    marginBottom: "24px",
  }),
  Form: styled(Form)({
    width: "100%",
    display: "flex",
  }),
  Title: styled("div")({
    color: "#484848",
    marginBottom: "8px",
    fontFamily: "Roboto, sans-serif",
    fontSize: "large",
    fontWeight: 500,
  }),
};
